<template>
  <div class="app-container">
    <div class="filter-container">
      <el-input
        v-model="listQuery.username"
        placeholder="用户名"
        style="width: 200px;"
        class="filter-item"
        @keyup.enter.native="handleFilter"
      />
      <el-select v-model="listQuery.status" placeholder="状态" class="filter-item" style="width: 120px;" clearable>
        <el-option label="启用" :value="1" />
        <el-option label="禁用" :value="0" />
      </el-select>
      <el-button v-waves class="filter-item" type="primary" icon="el-icon-search" @click="handleFilter">
        搜索
      </el-button>
      <el-button
        class="filter-item"
        style="margin-left: 10px;"
        type="primary"
        icon="el-icon-edit"
        @click="handleCreate"
      >
        添加
      </el-button>
    </div>

    <el-table
      :key="tableKey"
      v-loading="listLoading"
      :data="list"
      border
      fit
      highlight-current-row
      style="width: 100%;"
    >
      <el-table-column label="用户名" min-width="150" align="center">
        <template slot-scope="{row}">
          <span>{{ row.username }}</span>
        </template>
      </el-table-column>
      <el-table-column label="姓名" min-width="120" align="center">
        <template slot-scope="{row}">
          <span>{{ row.nickname || '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="年龄" width="80" align="center">
        <template slot-scope="{row}">
          <span>{{ row.age !== undefined && row.age !== null ? row.age : '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="电话" width="150" align="center">
        <template slot-scope="{row}">
          <span>{{ row.phone }}</span>
        </template>
      </el-table-column>
      <el-table-column label="关联员工" min-width="140" align="center">
        <template slot-scope="{row}">
          <span>{{ (row.employee && (row.employee.name || row.employee.code)) || '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="部门" min-width="180" align="center" show-overflow-tooltip>
        <template slot-scope="{row}">
          <span>{{ formatDepartmentNames(row.departments || row.department) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="状态" class-name="status-col" width="100" align="center">
        <template slot-scope="{row}">
          <el-tag :type="row.status | statusFilter">
            {{ row.status === 1 ? '启用' : '禁用' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="140" class-name="small-padding fixed-width">
        <template slot-scope="{row}">
          <el-dropdown trigger="click" @command="command => handleAction(command, row)">
            <el-button type="primary" size="mini">
              操作<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="edit">编辑用户</el-dropdown-item>
            <el-dropdown-item command="relation">关联配置</el-dropdown-item>
              <el-dropdown-item command="password">修改密码</el-dropdown-item>
              <el-dropdown-item v-if="row.status === 0" command="enable">启用</el-dropdown-item>
              <el-dropdown-item v-if="row.status === 1" command="disable">禁用</el-dropdown-item>
              <el-dropdown-item divided command="delete">删除</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>

    <pagination v-show="total>0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.size" @pagination="getList" />

    <el-dialog :title="textMap[dialogStatus]" :visible.sync="dialogFormVisible" width="600px" class="common-dialog">
      <el-form ref="dataForm" :rules="currentDataFormRules" :model="temp" label-position="left" label-width="80px" class="common-dialog-form">
        <div v-if="dialogStatus==='create'" class="pwd-rule-card">
          <div class="pwd-rule-card__head">
            <i class="el-icon-lock pwd-rule-card__icon" />
            <span class="pwd-rule-card__title">密码规则要求</span>
          </div>
          <ol class="pwd-rule-card__list">
            <li>长度至少 8 位</li>
            <li>须包含大写字母、小写字母、数字、特殊字符中的至少三种</li>
            <li>禁止使用常见弱口令（如 "123456"、"password" 等）</li>
            <li>不能与用户名相同（不区分大小写）</li>
          </ol>
        </div>
        <el-form-item label="用户名" prop="username">
          <el-input v-model="temp.username" :disabled="dialogStatus==='update'" placeholder="请输入用户名" />
        </el-form-item>
        <el-form-item label="姓名">
          <el-input v-model="temp.nickname" placeholder="请输入姓名" />
        </el-form-item>
        <el-form-item label="身份证号" prop="idCard">
          <el-input v-model="temp.idCard" placeholder="请输入身份证号" />
        </el-form-item>
        <el-form-item label="年龄" prop="age">
          <el-input-number v-model="temp.age" :min="0" :max="120" disabled />
        </el-form-item>
        <el-form-item v-if="dialogStatus==='create'" label="密码" prop="password">
          <el-input
            v-model="temp.password"
            type="password"
            placeholder="请输入密码"
            autocomplete="new-password"
            show-password
          />
        </el-form-item>
        <el-form-item label="邮箱" prop="email">
          <el-input v-model="temp.email" placeholder="请输入邮箱" />
        </el-form-item>
        <el-form-item label="电话" prop="phone">
          <el-input v-model="temp.phone" placeholder="请输入电话" />
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="temp.status" class="filter-item" placeholder="请选择状态" style="width: 100%;">
            <el-option v-for="item in statusOptions" :key="item.key" :label="item.display_name" :value="item.key" />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">
          取消
        </el-button>
        <el-button type="primary" @click="dialogStatus==='create'?createData():updateData()">
          确认
        </el-button>
      </div>
    </el-dialog>

    <el-dialog title="关联配置" :visible.sync="relationDialogVisible" width="560px" class="common-dialog">
      <el-form :model="relationForm" label-position="left" label-width="100px" class="common-dialog-form">
        <el-form-item label="用户名">
          <el-input v-model="relationForm.username" disabled />
        </el-form-item>
        <el-form-item label="角色">
          <el-select
            v-model="relationForm.roleIds"
            multiple
            clearable
            collapse-tags
            placeholder="请选择角色"
            style="width: 100%;"
          >
            <el-option
              v-for="role in roleList"
              :key="role.id"
              :label="role.roleName || role.name"
              :value="role.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="部门">
          <el-select
            v-model="relationForm.departmentIds"
            multiple
            clearable
            collapse-tags
            placeholder="请选择部门"
            style="width: 100%;"
          >
            <el-option
              v-for="dept in departmentList"
              :key="dept.id"
              :label="dept.deptName || dept.name"
              :value="dept.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="员工">
          <el-select
            v-model="relationForm.employeeId"
            filterable
            clearable
            placeholder="请选择员工，可留空"
            style="width: 100%;"
          >
            <el-option
              v-for="employee in employeeList"
              :key="employee.id"
              :label="formatEmployeeLabel(employee)"
              :value="employee.id"
            />
          </el-select>
          <div style="margin-top: 6px; color: #909399; font-size: 12px;">
            角色、部门、员工均可独立配置；留空表示不关联该项。
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="relationDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="relationSaving" @click="handleUpdateRelation">确认</el-button>
      </div>
    </el-dialog>

    <!-- 修改密码对话框 -->
    <el-dialog title="修改密码" :visible.sync="passwordDialogVisible" width="500px" class="common-dialog">
      <el-form ref="passwordForm" :rules="passwordFormRulesComputed" :model="passwordForm" label-position="left" label-width="100px" class="common-dialog-form">
        <div class="pwd-rule-card pwd-rule-card--compact">
          <div class="pwd-rule-card__head">
            <i class="el-icon-lock pwd-rule-card__icon" />
            <span class="pwd-rule-card__title">密码规则要求</span>
          </div>
          <ol class="pwd-rule-card__list">
            <li>长度至少 8 位</li>
            <li>须包含大写字母、小写字母、数字、特殊字符中的至少三种</li>
            <li>禁止使用常见弱口令（如 "123456"、"password" 等）</li>
            <li>不能与用户名相同（不区分大小写）</li>
          </ol>
        </div>
        <el-form-item label="用户名">
          <el-input v-model="passwordForm.username" disabled />
        </el-form-item>
        <el-form-item label="新密码" prop="newPassword">
          <el-input
            v-model="passwordForm.newPassword"
            type="password"
            placeholder="请输入新密码"
            autocomplete="new-password"
            show-password
          />
        </el-form-item>
        <el-form-item label="确认密码" prop="confirmPassword">
          <el-input
            v-model="passwordForm.confirmPassword"
            type="password"
            placeholder="请再次输入新密码"
            autocomplete="new-password"
            show-password
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="passwordDialogVisible = false">
          取消
        </el-button>
        <el-button type="primary" @click="handleUpdatePassword">
          确认
        </el-button>
      </div>
    </el-dialog>

    <!-- 编辑部门对话框 -->
    <el-dialog title="编辑部门" :visible.sync="departmentDialogVisible" width="500px" class="common-dialog">
      <el-form ref="departmentFormRef" :model="departmentForm" label-position="left" label-width="100px" class="common-dialog-form">
        <el-form-item label="用户名">
          <el-input v-model="departmentForm.username" disabled />
        </el-form-item>
        <el-form-item label="部门">
          <el-select
            v-model="departmentForm.departmentIds"
            multiple
            placeholder="请选择部门"
            style="width: 100%;"
            clearable
          >
            <el-option
              v-for="dept in departmentList"
              :key="dept.id"
              :label="dept.deptName || dept.name"
              :value="dept.id"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="departmentDialogVisible = false">
          取消
        </el-button>
        <el-button type="primary" @click="handleUpdateDepartment">
          确认
        </el-button>
      </div>
    </el-dialog>

    <!-- 编辑角色对话框 -->
    <el-dialog title="编辑角色" :visible.sync="roleDialogVisible" width="500px" class="common-dialog">
      <el-form ref="roleFormRef" :model="roleForm" label-position="left" label-width="100px" class="common-dialog-form">
        <el-form-item label="用户名">
          <el-input v-model="roleForm.username" disabled />
        </el-form-item>
        <el-form-item label="角色">
          <el-select
            v-model="roleForm.roleIds"
            multiple
            placeholder="请选择角色"
            style="width: 100%;"
            clearable
          >
            <el-option
              v-for="role in roleList"
              :key="role.id"
              :label="role.roleName || role.name"
              :value="role.id"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="roleDialogVisible = false">
          取消
        </el-button>
        <el-button type="primary" @click="handleUpdateRole">
          确认
        </el-button>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="dialogPvVisible" title="阅读数统计" class="common-dialog">
      <el-table :data="pvData" border fit highlight-current-row style="width: 100%">
        <el-table-column prop="key" label="渠道" />
        <el-table-column prop="pv" label="PV" />
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogPvVisible = false">确认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getUserList, getUserById, getUserRoles, getUserDepartments, createUser, updateUser, updateUserPassword, updateUserRoles, updateUserDepartments, updateUserEmployee, deleteUser } from '../../../api/user'
import { getAllEmployees } from '../../../api/employee'
import { getAllRoles } from '../../../api/role'
import { getAllDepartments } from '../../../api/department'
import waves from '../../../directive/waves' // waves directive
import { getPasswordPolicyError } from '../../../utils/passwordPolicy'
import { parseTime } from '../../../utils/index'
import Pagination from '../../../components/Pagination' // secondary package based on el-pagination

export default {
  name: 'UserTable',
  components: { Pagination },
  directives: { waves },
  filters: {
    statusFilter(status) {
      const statusMap = {
        1: 'success',
        0: 'danger'
      }
      return statusMap[status]
    }
  },
  watch: {
    'temp.idCard'(value) {
      const age = this.calculateAgeFromIdCard(value)
      if (age !== null) {
        this.temp.age = age
      }
    },
    'temp.username'(value, oldVal) {
      if (this.dialogStatus === 'create' && this.temp.password && oldVal !== value) {
        this.$nextTick(() => {
          if (this.$refs.dataForm) {
            this.$refs.dataForm.validateField('password')
          }
        })
      }
    },
    'passwordForm.newPassword'() {
      if (this.passwordForm.confirmPassword) {
        this.$nextTick(() => {
          if (this.$refs.passwordForm) {
            this.$refs.passwordForm.validateField('confirmPassword')
          }
        })
      }
    }
  },
  data() {
    return {
      tableKey: 0,
      list: null,
      total: 0,
      listLoading: true,
      listQuery: {
        page: 1,
        size: 10,
        username: undefined,
        status: undefined
      },
      statusOptions: [
        { key: 1, display_name: '启用' },
        { key: 0, display_name: '禁用' }
      ],
      roleList: [], // 角色列表
      departmentList: [], // 部门列表
      employeeList: [], // 员工列表
      temp: {
        id: undefined,
        username: '',
        nickname: '',
        idCard: '',
        age: undefined,
        password: '',
        email: '',
        phone: '',
        status: 1,
        departmentIds: [] // 部门ID数组
      },
      dialogFormVisible: false,
      dialogStatus: '',
      textMap: {
        update: '编辑用户',
        create: '创建用户'
      },
      relationDialogVisible: false,
      relationSaving: false,
      relationForm: {
        id: undefined,
        username: '',
        roleIds: [],
        departmentIds: [],
        employeeId: null
      },
      passwordDialogVisible: false,
      departmentDialogVisible: false,
      roleDialogVisible: false,
      passwordForm: {
        id: undefined,
        username: '',
        newPassword: '',
        confirmPassword: ''
      },
      departmentForm: {
        id: undefined,
        username: '',
        departmentIds: []
      },
      roleForm: {
        id: undefined,
        username: '',
        roleIds: []
      },
      passwordRules: {
        confirmPassword: [
          { required: true, message: '请再次输入新密码', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (value !== this.passwordForm.newPassword) {
                callback(new Error('两次输入的密码不一致'))
              } else {
                callback()
              }
            },
            trigger: 'blur'
          }
        ]
      },
      dialogPvVisible: false,
      pvData: [],
      rules: {
        username: [{ required: true, message: '用户名不能为空', trigger: 'blur' }],
        idCard: [
          { required: true, message: '身份证号不能为空', trigger: 'blur' },
          { pattern: /(^\d{15}$)|(^\d{17}[\dXx]$)/, message: '请输入正确的身份证号', trigger: 'blur' }
        ],
        email: [
          { required: true, message: '邮箱不能为空', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
        ],
        phone: [
          { required: true, message: '电话不能为空', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
        ]
      },
      downloadLoading: false
    }
  },
  computed: {
    currentDataFormRules() {
      const base = {
        username: this.rules.username,
        idCard: this.rules.idCard,
        email: this.rules.email,
        phone: this.rules.phone
      }
      if (this.dialogStatus !== 'create') {
        return base
      }
      return {
        ...base,
        password: [
          { required: true, message: '密码不能为空', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              const err = getPasswordPolicyError(value, this.temp.username)
              if (err) callback(new Error(err))
              else callback()
            },
            trigger: ['blur', 'change']
          }
        ]
      }
    },
    passwordFormRulesComputed() {
      return {
        newPassword: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              const err = getPasswordPolicyError(value, this.passwordForm.username)
              if (err) callback(new Error(err))
              else callback()
            },
            trigger: ['blur', 'change']
          }
        ],
        confirmPassword: this.passwordRules.confirmPassword
      }
    }
  },
  created() {
    this.getList()
    this.getRoleList()
    this.getDepartmentList()
    this.getEmployeeList()
  },
  methods: {
    normalizeIds(list) {
      if (!Array.isArray(list)) return []
      return list.map(id => {
        const value = Number(id)
        return Number.isNaN(value) ? id : value
      })
    },
    getRoleList() {
      // 获取所有角色（用于选择）
      return getAllRoles().then(response => {
        const list = response && response.data ? response.data : []
        this.roleList = Array.isArray(list) ? list : []
        return this.roleList
      })
    },
    getList() {
      this.listLoading = true
      const data = {
        page: this.listQuery.page - 1,
        size: this.listQuery.size
      }
      if (this.listQuery.username) {
        data.username = this.listQuery.username
      }
      if (this.listQuery.status !== undefined && this.listQuery.status !== null && this.listQuery.status !== '') {
        data.status = this.listQuery.status
      }
      getUserList(data).then((payload) => {
        const pageData = payload && payload.data !== undefined ? payload.data : payload
        this.list = Array.isArray(pageData && pageData.content) ? pageData.content : []
        this.total =
          pageData &&
          typeof pageData.totalElements === 'number' &&
          pageData.totalElements >= 0
            ? pageData.totalElements
            : 0
        this.tableKey += 1
        this.listLoading = false
      }).catch(() => {
        this.listLoading = false
      })
    },
    getDepartmentList() {
      // 获取所有部门（用于选择）
      return getAllDepartments().then(response => {
        const list = response && response.data ? response.data : []
        this.departmentList = Array.isArray(list)
          ? list.map(dept => ({
            ...dept,
            id: Number.isNaN(Number(dept.id)) ? dept.id : Number(dept.id)
          }))
          : []
        return this.departmentList
      })
    },
    getEmployeeList() {
      return getAllEmployees().then(response => {
        const list = response && response.data ? response.data : []
        this.employeeList = Array.isArray(list)
          ? list.map(employee => ({
            ...employee,
            id: Number.isNaN(Number(employee.id)) ? employee.id : Number(employee.id)
          }))
          : []
        return this.employeeList
      })
    },
    formatEmployeeLabel(employee) {
      const name = employee && employee.name ? employee.name : '-'
      const code = employee && employee.code ? ` (${employee.code})` : ''
      return `${name}${code}`
    },
    formatDepartmentNames(raw) {
      if (raw == null || raw === '') return '-'
      const list = Array.isArray(raw) ? raw : typeof raw === 'object' ? [raw] : []
      if (!list.length) return '-'
      const names = list
        .map((dept) => {
          if (dept == null || typeof dept !== 'object') return ''
          return (
            dept.deptName ||
            dept.name ||
            dept.dept_name ||
            dept.title ||
            dept.label ||
            ''
          )
        })
        .filter(Boolean)
      return names.length ? names.join('、') : '-'
    },
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    resetTemp() {
      this.temp = {
        id: undefined,
        username: '',
        nickname: '',
        idCard: '',
        age: undefined,
        password: '',
        email: '',
        phone: '',
        status: 1,
        departmentIds: []
      }
    },
    handleCreate() {
      this.resetTemp()
      this.dialogStatus = 'create'
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    createData() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          const payload = {
            username: this.temp.username,
            nickname: this.temp.nickname,
            idCard: this.temp.idCard,
            age: this.temp.age,
            password: this.temp.password,
            email: this.temp.email,
            phone: this.temp.phone,
            status: this.temp.status
          }
          createUser(payload).then(() => {
            this.getList()
            this.dialogFormVisible = false
            this.$notify({
              title: '成功',
              message: '创建成功',
              type: 'success',
              duration: 2000
            })
          }).catch(() => {
            // 错误已在拦截器中处理
          })
        }
      })
    },
    handleUpdate(row) {
      // 获取用户详情，包含角色和部门信息
      this.temp = {
        id: row.id,
        username: row.username || '',
        nickname: row.nickname || '',
        idCard: row.idCard || '',
        age: row.age !== undefined && row.age !== null ? row.age : undefined,
        email: row.email || '',
        phone: row.phone || '',
        status: row.status !== undefined ? row.status : 1,
        departmentIds: []
      }
      
      // 处理部门信息
      if (row.departments && Array.isArray(row.departments) && row.departments.length > 0) {
        this.temp.departmentIds = row.departments.map(dept => dept.id).filter(id => id !== undefined && id !== null)
      } else if (row.departmentIds) {
        this.temp.departmentIds = Array.isArray(row.departmentIds) ? row.departmentIds.filter(id => id !== undefined && id !== null) : [row.departmentIds].filter(id => id !== undefined && id !== null)
      }
      
      this.dialogStatus = 'update'
      this.dialogFormVisible = true
      this.$nextTick(() => {
        if (this.$refs['dataForm']) {
        this.$refs['dataForm'].clearValidate()
        }
      })
    },
    handleResetPassword(row) {
      // 打开修改密码对话框
      this.passwordForm = {
        id: row.id,
        username: row.username || '',
        newPassword: '',
        confirmPassword: ''
      }
      this.passwordDialogVisible = true
      this.$nextTick(() => {
        if (this.$refs['passwordForm']) {
          this.$refs['passwordForm'].clearValidate()
        }
      })
    },
    async handleManageRole(row) {
      this.roleForm = {
        id: row.id,
        username: row.username || '',
        roleIds: []
      }
      await this.getRoleList()
      try {
        const response = await getUserRoles(row.id)
        const roles = Array.isArray(response.data) ? response.data : []
        this.roleForm.roleIds = roles.map(role => role.id).filter(id => id !== undefined && id !== null)
      } catch (e) {
        // 回退到列表行数据
        if (row.roles && Array.isArray(row.roles) && row.roles.length > 0) {
          this.roleForm.roleIds = row.roles.map(role => role.id).filter(id => id !== undefined && id !== null)
        } else if (row.roleIds) {
          this.roleForm.roleIds = Array.isArray(row.roleIds) ? row.roleIds.filter(id => id !== undefined && id !== null) : [row.roleIds].filter(id => id !== undefined && id !== null)
        }
      }
      this.roleDialogVisible = true
      this.$nextTick(() => {
        if (this.$refs['roleFormRef']) {
          this.$refs['roleFormRef'].clearValidate()
        }
      })
    },
    async handleManageRelation(row) {
      this.relationForm = {
        id: row.id,
        username: row.username || '',
        roleIds: [],
        departmentIds: [],
        employeeId: null
      }
      this.relationDialogVisible = true
      await Promise.all([
        this.getRoleList(),
        this.getDepartmentList(),
        this.getEmployeeList()
      ])
      try {
        const [userResp, roleResp, deptResp] = await Promise.all([
          getUserById(row.id),
          getUserRoles(row.id),
          getUserDepartments(row.id)
        ])
        const user = userResp && userResp.data ? userResp.data : {}
        const roles = Array.isArray(roleResp.data) ? roleResp.data : []
        const departments = Array.isArray(deptResp.data) ? deptResp.data : []
        this.relationForm.roleIds = roles.map(role => role.id).filter(id => id !== undefined && id !== null)
        this.relationForm.departmentIds = this.normalizeIds(
          departments.map(dept => dept.id).filter(id => id !== undefined && id !== null)
        )
        this.relationForm.employeeId = user.employeeId || (user.employee && user.employee.id) || null
      } catch (e) {
        this.relationForm.employeeId = row.employeeId || (row.employee && row.employee.id) || null
      }
    },
    handleUpdateRelation() {
      this.relationSaving = true
      Promise.all([
        updateUserRoles({
          id: this.relationForm.id,
          roleIds: this.relationForm.roleIds
        }),
        updateUserDepartments({
          id: this.relationForm.id,
          departmentIds: this.relationForm.departmentIds
        }),
        updateUserEmployee({
          id: this.relationForm.id,
          employeeId: this.relationForm.employeeId
        })
      ]).then(() => {
        this.relationSaving = false
        this.relationDialogVisible = false
        this.getList()
        this.$notify({
          title: '成功',
          message: '关联配置更新成功',
          type: 'success',
          duration: 2000
        })
      }).catch(() => {
        this.relationSaving = false
      })
    },
    handleUpdateRole() {
      const payload = {
        id: this.roleForm.id,
        roleIds: this.roleForm.roleIds
      }
      updateUserRoles(payload).then(() => {
        this.roleDialogVisible = false
        this.getList()
        this.$notify({
          title: '成功',
          message: '角色更新成功',
          type: 'success',
          duration: 2000
        })
      }).catch(() => {
        // 错误已在拦截器中处理
      })
    },
    handleManageDepartment(row) {
      this.departmentForm = {
        id: row.id,
        username: row.username || '',
        departmentIds: []
      }
      this.departmentDialogVisible = true
      getUserDepartments(row.id).then(response => {
        const departments = Array.isArray(response.data) ? response.data : []
        this.departmentForm.departmentIds = this.normalizeIds(
          departments.map(dept => dept.id).filter(id => id !== undefined && id !== null)
        )
      }).catch(() => {
        // 回退到列表行数据
        if (row.departments && Array.isArray(row.departments) && row.departments.length > 0) {
          this.departmentForm.departmentIds = this.normalizeIds(
            row.departments.map(dept => dept.id).filter(id => id !== undefined && id !== null)
          )
        } else if (row.departmentIds) {
          const ids = Array.isArray(row.departmentIds)
            ? row.departmentIds.filter(id => id !== undefined && id !== null)
            : [row.departmentIds].filter(id => id !== undefined && id !== null)
          this.departmentForm.departmentIds = this.normalizeIds(ids)
        }
      })
    },
    handleUpdateDepartment() {
      const payload = {
        id: this.departmentForm.id,
        departmentIds: this.departmentForm.departmentIds
      }
      updateUserDepartments(payload).then(() => {
        this.departmentDialogVisible = false
        this.getList()
        this.$notify({
          title: '成功',
          message: '部门更新成功',
          type: 'success',
          duration: 2000
        })
      }).catch(() => {
        // 错误已在拦截器中处理
      })
    },
    handleAction(command, row) {
      switch (command) {
        case 'edit':
          this.handleUpdate(row)
          break
        case 'relation':
          this.handleManageRelation(row)
          break
        case 'password':
          this.handleResetPassword(row)
          break
        case 'enable':
          this.handleModifyStatus(row, 'enabled')
          break
        case 'disable':
          this.handleModifyStatus(row, 'disabled')
          break
        case 'delete':
          this.handleDelete(row)
          break
        default:
          break
      }
    },
    calculateAgeFromIdCard(idCard) {
      if (!idCard) {
        return null
      }
      const value = String(idCard).trim()
      let birth
      if (/^\d{17}[\dXx]$/.test(value)) {
        birth = value.substring(6, 14) // yyyyMMdd
      } else if (/^\d{15}$/.test(value)) {
        birth = `19${value.substring(6, 12)}` // yyMMdd -> 19yyMMdd
      } else {
        return null
      }
      const year = Number(birth.substring(0, 4))
      const month = Number(birth.substring(4, 6))
      const day = Number(birth.substring(6, 8))
      if (!year || !month || !day) {
        return null
      }
      const today = new Date()
      let age = today.getFullYear() - year
      const m = today.getMonth() + 1
      const d = today.getDate()
      if (m < month || (m === month && d < day)) {
        age -= 1
      }
      return age
    },
    handleUpdatePassword() {
      this.$refs['passwordForm'].validate((valid) => {
        if (valid) {
          // 调用更新接口，只传递密码
          const passwordData = {
            id: this.passwordForm.id,
            password: this.passwordForm.newPassword
          }
          updateUserPassword(passwordData).then(() => {
            this.passwordDialogVisible = false
            this.$notify({
              title: '成功',
              message: '密码修改成功',
              type: 'success',
              duration: 2000
            })
            // 重置表单
            this.passwordForm = {
              id: undefined,
              username: '',
              newPassword: '',
              confirmPassword: ''
            }
          }).catch(() => {
            // 错误已在拦截器中处理
          })
        }
      })
    },
    updateData() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          const tempData = Object.assign({}, this.temp)
          // 编辑时不传递密码字段
          delete tempData.password
          delete tempData.departmentIds
          updateUser(tempData).then(() => {
            this.getList()
            this.dialogFormVisible = false
            this.$notify({
              title: '成功',
              message: '更新成功',
              type: 'success',
              duration: 2000
            })
          }).catch(() => {
            // 错误已在拦截器中处理
          })
        }
      })
    },
    handleModifyStatus(row, status) {
      const statusText = status === 'enabled' ? '启用' : '禁用'
      const newStatus = status === 'enabled' ? 1 : 0
      this.$confirm(`此操作将${statusText}该用户, 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const tempData = Object.assign({}, row)
        tempData.status = newStatus
        updateUser(tempData).then(() => {
          this.getList()
          this.$notify({
            title: '成功',
            message: `${statusText}成功`,
            type: 'success',
            duration: 2000
          })
        }).catch(() => {
          // 错误已在拦截器中处理
        })
      })
    },
    handleDelete(row) {
      this.$confirm('此操作将永久删除该用户, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteUser(row.id).then(() => {
          this.$notify({
            title: '成功',
            message: '删除成功',
            type: 'success',
            duration: 2000
          })
          // 重新获取列表，确保分页正确
          this.getList()
        }).catch(() => {
          // 错误已在拦截器中处理
        })
      })
    },
    handleDownload() {
      this.downloadLoading = true
      // 注释掉Excel导出功能，因为目前没有这个依赖
      // import('../../../vendor/Export2Excel').then(excel => {
      //   const tHeader = ['timestamp', 'title', 'type', 'importance', 'status']
      //   const filterVal = ['timestamp', 'title', 'type', 'importance', 'status']
      //   const data = this.formatJson(filterVal)
      //   excel.export_json_to_excel({
      //     header: tHeader,
      //     data,
      //     filename: 'table-list'
      //   })
      //   this.downloadLoading = false
      // })
    },
    formatJson(filterVal) {
      return this.list.map(v => filterVal.map(j => {
        if (j === 'timestamp') {
          return parseTime(v[j])
        } else {
          return v[j]
        }
      }))
    }
  }
}
</script>

<style scoped>
.pwd-rule-card {
  margin: 0 0 20px;
  padding: 12px 14px;
  background: #e8f2fc;
  border: 1px solid #cce6ff;
  border-radius: 8px;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.75);
}

.pwd-rule-card--compact {
  margin-bottom: 16px;
}

.pwd-rule-card__head {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  padding-bottom: 8px;
  border-bottom: 1px solid rgba(64, 158, 255, 0.22);
}

.pwd-rule-card__icon {
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  margin-right: 8px;
  font-size: 13px;
  line-height: 24px;
  text-align: center;
  color: #409eff;
  background: rgba(255, 255, 255, 0.75);
  border-radius: 6px;
}

.pwd-rule-card__title {
  font-size: 12px;
  font-weight: 600;
  color: #303133;
  letter-spacing: 0.02em;
}

.pwd-rule-card__list {
  margin: 0;
  padding-left: 1.25em;
  font-size: 12px;
  color: #545c6b;
  line-height: 1.6;
}

.pwd-rule-card__list li {
  margin-bottom: 3px;
  padding-left: 1px;
}

.pwd-rule-card__list li:last-child {
  margin-bottom: 0;
}
</style>
